import { models } from '@kurtosys/ksys-app-components';

import { Breakpoints } from './Breakpoints.js';

export function useBreakpointValue<TBreakpointValue>(
	breakpointValues: Record<models.TBreakpointSize, TBreakpointValue>,
): TBreakpointValue {
	return breakpointValues[Breakpoints.active];
}
